<template>
  <div>
    <h5>System Settings</h5>
    <top-nav>
      <li>
        <router-link :to="{ name: 'branches.list'}"
                     v-if="$can.view($store.getters.getAuthUser, 'list-branches')">
          Branches
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'settings.bidbonds'}">
          BidBond Limits
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'settings.pricing'}">
          BidBond Pricing Settings
        </router-link>
      </li>
      <li v-if="$can.view($store.getters.getAuthUser, 'kyc-settings')">
        <router-link :to="{name: 'settings.kyc'}">
          Disable KYC
        </router-link>
      </li>
    </top-nav>
  </div>
</template>
<script>
    import TopNav from "@/components/TopNav.vue";

    export default {
        components: {
            TopNav
        }
    }
</script>

